import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";
import { motion } from "framer-motion";
import { FiCheck } from "react-icons/fi";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = () => {
    if (!email) return;
    setSubscribed(true);
    setEmail("");
    setTimeout(() => setSubscribed(false), 2000);
  };

  return (
    <footer className="relative bg-white overflow-hidden border-t border-gray-200">
      {/* Floating background shapes */}
      <motion.div
        className="absolute -top-20 -left-20 w-48 h-48 rounded-full bg-red-700/5 blur-3xl"
        animate={{ x: [0, 30, 0], y: [0, 20, 0] }}
        transition={{ duration: 15, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute -bottom-20 -right-20 w-60 h-60 rounded-full bg-red-700/5 blur-3xl"
        animate={{ x: [0, -30, 0], y: [0, -20, 0] }}
        transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-12 relative ">
        {/* Logo & About */}
        <div className="space-y-4">
          <h2 className="text-3xl sm:text-4xl  text-red-700  font-semibold">
            Supizza
          </h2>
          <p className="text-sm sm:text-base font-light leading-relaxed text-gray-700 pr-10">
            Premium pizza{" "}
            <span className="text-red-700 font-thin">delivered fast</span>.
            Fresh ingredients, thin crust, and flavors that pop.
          </p>
          <div className="flex gap-4 mt-2">
            {[FaFacebookF, FaInstagram, FaTwitter].map((Icon, idx) => (
              <motion.a
                key={idx}
                href="#"
                className="text-gray-500 hover:text-red-700 transition-colors duration-300"
                whileHover={{ scale: 1.1 }}
              >
                <Icon size={18} />
              </motion.a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div className="space-y-4">
          <h3 className="text-lg  text-red-700 tracking-widest uppercase font-thin">
            Quick Links
          </h3>
          <ul className="space-y-2 text-sm sm:text-base font-light text-gray-700">
            {[
              { name: "Home", to: "/" },
              { name: "Menu", to: "/menu" },
              { name: "Contact", to: "/contact" },
            ].map((link, i) => (
              <li key={i}>
                <Link
                  to={link.to}
                  className="hover:text-red-700 transition-all duration-300 tracking-wide"
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Newsletter / Contact */}
        <div className="space-y-4">
          <h3 className="text-lg font-thin text-red-700 tracking-widest uppercase">
            Subscribe & Contact
          </h3>
          <p className="text-sm sm:text-base font-light text-gray-700 leading-relaxed">
            Get{" "}
            <span className="text-red-700 font-thin">updates & promotions</span>{" "}
            straight to your inbox.
          </p>
          <div className="flex gap-2">
            <input
              type="email"
              placeholder="Your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="px-4 py-2 rounded-l-full border border-gray-300 text-sm sm:text-base font-light outline-none w-full placeholder-gray-400"
            />
            <button
              onClick={handleSubscribe}
              className={`px-6 py-2 rounded-r-full ${
                subscribed ? "bg-green-500" : "bg-red-700"
              } text-white font-thin hover:bg-red-800 transition flex items-center justify-center`}
            >
              {subscribed ? <FiCheck size={20} /> : "Subscribe"}
            </button>
          </div>
          <p className="text-sm sm:text-base font-light text-gray-700 mt-4 leading-relaxed">
            123 Pizza Street, Food City <br />
            info@supizza.com <br />
            +1 234 567 890
          </p>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-gray-200 mt-8 py-4 text-center text-xs sm:text-sm font-light text-gray-500 relative  tracking-wide leading-relaxed">
        &copy; {new Date().getFullYear()} Supizza. All rights reserved.
      </div>
    </footer>
  );
}
